// import update from "immutability-helper";
import {
    SET_TABLE_RECORDS,
    UPDATE_TABLE_RECORDS,
    SET_LOOKUP_FIELDS_RECORDS,
    RESET_TABLE_RECORDS
} from "../actionTypes/GridListActionTypes";
import { defaultPerpageUsingWindowId } from '../../Utils/UserFunctions';

const tableRecordsObj = {
  selectedRows:[],
  gridList:[],
  splitViewGridList:[],
  layoutAddType:0,
  tableHead:[],
  tableData:[], 
  pagination:{
    page:0,
    orderBy:'',
    perPage:10,
    direction:'ASC',
    totalRecords:0,
    search:'',
  },
  layout_details:{},
  gridFilter:{},
  columnSort :{},
  gridView:'LIST',
  calendarViewType:'MONTH',
  kanbanViewContent:null,
  kanbanViewProperties:null,
  calendarViewContent:{},
  calendarViewProperties:null,
  calendarGridFilter:{},
  isShowCalendarGridView:false,
  isShowActivities:false,
  calendarViewActivities:null,
  calendarGridFilterActivities:{},
};
const initialState = {
  tableRecords:{
    ...tableRecordsObj
  },
  lookupFieldsRecord:{},
  detailViewTab:[]
};


const GridListReducer = (state = initialState, action) => {

  let updateTableRecords = null,keyObj = null,data=null,lookupFieldsRecord=null
  const {type,payload} = action;
  
  // let perPage = 10;
  // console.log(payload);
  switch (type) {
    case SET_TABLE_RECORDS:
        updateTableRecords = {...payload};
        return {
            ...state,
            tableRecords:updateTableRecords
        }
    case RESET_TABLE_RECORDS:
        const {params} = payload;
        const userPerPage = defaultPerpageUsingWindowId(params.windowId);
        updateTableRecords = {
          selectedRows:[],
          gridList:[],
          splitViewGridList:[],
          // layoutAddType:0,
          tableHead:[],
          tableData:[], 
          pagination:{
            page:0,
            orderBy:'',
            perPage:userPerPage?userPerPage:10,
            direction:'ASC',
            totalRecords:0,
            search:'',
          },
          layoutAddType:0,
          gridFilter:{},
          columnSort :{},
          gridView:'LIST',
          calendarViewType:'MONTH',
          kanbanViewContent:null,
          kanbanViewProperties:null,
          calendarViewContent:{},
          calendarViewProperties:null,
          calendarGridFilter:{},    
          isShowCalendarGridView:false,
          //calendarViewTypeEnum:'MONTH',
          isShowActivities:false,
          calendarViewActivities:null,      
        };
        return {
            ...state,
            tableRecords:updateTableRecords
        }    
    case UPDATE_TABLE_RECORDS:
        keyObj = payload.keyObj
        data = payload.data;
        // console.log('keyObj',keyObj,data);
        updateTableRecords = {
            ...state.tableRecords,
            [keyObj]:data
        };
        return{
            ...state,
            tableRecords:updateTableRecords
        }
    case SET_LOOKUP_FIELDS_RECORDS:
      lookupFieldsRecord = {
        ...payload
      }  
      return{
        ...state,
        lookupFieldsRecord:lookupFieldsRecord
      }
    default:
      return state;
  }
};

export default GridListReducer;